import React from 'react';
export function Organization() {
  return <div data-id="element-2431">
      <div className="flex justify-between items-center mb-6" data-id="element-2432">
        <h1 className="text-2xl font-bold" data-id="element-2433">Organization Settings</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2434">
          Save Changes
        </button>
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-2435">
        <h2 className="text-lg font-medium mb-4" data-id="element-2436">Company Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2437">
          <div data-id="element-2438">
            <label className="block text-sm font-medium mb-1" htmlFor="companyName" data-id="element-2439">
              Company Name
            </label>
            <input id="companyName" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="ABC Insurance Agency" data-id="element-2440" />
          </div>
          <div data-id="element-2441">
            <label className="block text-sm font-medium mb-1" htmlFor="phone" data-id="element-2442">
              Phone
            </label>
            <input id="phone" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="(555) 123-4567" data-id="element-2443" />
          </div>
          <div data-id="element-2444">
            <label className="block text-sm font-medium mb-1" htmlFor="email" data-id="element-2445">
              Email
            </label>
            <input id="email" type="email" className="w-full border border-neutral-300 rounded p-2" defaultValue="contact@abcinsurance.com" data-id="element-2446" />
          </div>
          <div data-id="element-2447">
            <label className="block text-sm font-medium mb-1" htmlFor="website" data-id="element-2448">
              Website
            </label>
            <input id="website" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="www.abcinsurance.com" data-id="element-2449" />
          </div>
          <div className="md:col-span-2" data-id="element-2450">
            <label className="block text-sm font-medium mb-1" htmlFor="address" data-id="element-2451">
              Address
            </label>
            <textarea id="address" className="w-full border border-neutral-300 rounded p-2" rows={3} defaultValue="123 Insurance St, Business District, NY 12345" data-id="element-2452"></textarea>
          </div>
        </div>
      </div>
    </div>;
}